import { DatePicker, Select } from "antd";
import React, { useEffect, useState } from "react";

import { Link, useLocation, useParams } from "react-router-dom";

import { BASE_CRM_URL } from "../../../../components/config/config";
// import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";

import BillTo from "./BillTo";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import dayjs from "dayjs";

import EditProducttable from "../../../../../core/pagination/EditProducttable";

const EditEstimate = () => {
  //basic details and ids

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();

  console.log(state, "state................................");
  console.log("Customer ID:", state?.customerId);

  const customermainid = state?.customerId;
  console.log(customermainid);

  //get estimates details by id

  const [estimateDetails, setEstimateDetails] = useState({});
  const [loading, setLoading] = useState(false);

  console.log(estimateDetails, loading, "estimateDetails############");
  const getEstimatesById = async (id) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}estimates/GetEstimate/${id}`
      );

      const data = await response.json();

      console.log("Estimate API Response:", data);

      if (data.Status) {
        setEstimateDetails(data);
      }
    } catch (error) {
      console.error("Get Estimate Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEstimatesById(id);
  }, []);

  //states and apis for dropdowns

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [isCustomerPrefilled, setIsCustomerPrefilled] = useState(false);

  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(15, "day"));

  const [saving, setSaving] = useState(false);

  // const [itemOptions, setItemOptions] = useState([]);

  const [formData, setFormData] = useState({
    adminnote: "",
    clientnote: "",
    terms:
      "1) Warranty: 12 months from the date of installation. The materials are not covered if they fail due to power fluctuation, accidents, or physical damages. 2) Devices once installed or used will not be taken back (No Refund).",

    reference_no: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: null,

    project_id: null,
    adjustment: 0,
    currency: null,
  });

  useEffect(() => {
    if (!state) return;

    if (state.type === "customer") {
      const customer = state.record;

      setSelectedCustomer({
        value: customer.customerId,
        label: customer.company,
      });
      if (state.type === "customer") {
        fillEstimateDetails(state.record);
        setIsCustomerPrefilled(true);
      }
    }
  }, [state, countries]);

  const fillEstimateDetails = (customer) => {
    console.log("Customer Data.........:", customer);
    setFormData((prev) => ({
      ...prev,
      street: customer.address || "",
      city: customer.billing_city || "",
      state: customer.billing_state || "",
      zip: customer.billing_zip || "",
      country: customer.billing_country || null,
      currency: customer.default_currency,
    }));

    // setCurrencyId(customer.default_currency);

    setSelectedCountry(
      countries.find((c) => c.value === customer.billing_country) || null
    );

    setIsCustomerPrefilled(true);

    setSelectedCustomer({
      value: customer.customerId,
      label: customer.company,
    });
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };

  const getCountries = async () => {
    try {
      setCountryLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCountries`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.country_id,
          label: item.short_name,
        }));

        setCountries(options);

        // Optional: Set India as default if available
        const india = options.find(
          (item) => item.label === "India"
        );
        
        if (india) {
          setSelectedCountry(india);
        } else if (options.length > 0) {
          setSelectedCountry(options[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  useEffect(() => {
    getCountries();

    getCustomers();
  }, []);

  const [productData, setProductData] = useState({
    items: [],
    subtotal: 0,
    discount: 0,
    discountAmount: 0,
    discountType: "before",
    taxes: [],
    totalTax: 0,
    adjustment: 0,
    total: 0,
    currencyId: null,
    currencyName: null,
    currencySymbol: null,
  });



useEffect(() => {
  const estimate = estimateDetails?.Estimate;

  if (!estimate) return;

  setFormData((prev) => ({
    ...prev,

    adminnote: estimate.adminnote || "",
    clientnote: estimate.clientnote || "",
    terms: estimate.terms || "",
    reference_no: estimate.reference_no || "",

    street: estimate.billing_street || "",
    city: estimate.billing_city || "",
    state: estimate.billing_state || "",
    zip: estimate.billing_zip || "",

    country: estimate.billing_country || null,

    project_id: estimate.project_id || 0,
    adjustment: Number(estimate.adjustment || 0),
    currency: estimate.currency || null,
  }));

  // Estimated Date
  setStartDate(
    estimate.date
      ? dayjs(estimate.date)
      : null
  );

  // Expiry Date
  setEndDate(
    estimate.expirydate
      ? dayjs(estimate.expirydate)
      : null
  );

  // Product / calculation data
  setProductData((prev) => ({
    ...prev,

    subtotal: Number(estimate.subtotal || 0),

    discount: Number(
      estimate.discount_percent || 0
    ),

    discountAmount: Number(
      estimate.discount_total || 0
    ),

    discountType:
      estimate.discount_type || "before",

    totalTax: Number(
      estimate.total_tax || 0
    ),

    adjustment: Number(
      estimate.adjustment || 0
    ),

    total: Number(
      estimate.total || 0
    ),

    currencyId:
      estimate.currency !== null &&
      estimate.currency !== undefined
        ? Number(estimate.currency)
        : null,
  }));
}, [estimateDetails]);

  useEffect(() => {
    const estimate = estimateDetails?.Estimate;

    if (!estimate) return;

    // -------------------------
    // CUSTOMER
    // -------------------------
    const customer = customerOptions.find(
      (item) => Number(item.value) === Number(estimate.clientid)
    );

    if (customer) {
      setSelectedCustomer(customer);
    }

    // -------------------------
    // COUNTRY
    // -------------------------
    const country = countries.find(
      (item) => Number(item.value) === Number(estimate.billing_country)
    );

    if (country) {
      setSelectedCountry(country);
    }
  }, [estimateDetails, customerOptions, countries]);

  useEffect(() => {
    const itemable = estimateDetails?.Itemable || [];
    const estimateItems = estimateDetails?.Estimate?.items || [];
  
    if (!itemable.length) {
      return;
    }
  
    const formattedItems = itemable.map((item, index) => {
      const qty = Number(item.qty || 0);
      const rate = Number(item.rate || 0);
  
      // Find ALL estimate items for this product
      const matchingEstimateItems = estimateItems.filter(
        (estimateItem) =>
          estimateItem.description === item.description
      );
      // Combine all taxes
      const itemTaxes = matchingEstimateItems.flatMap(
        (estimateItem) =>
          (estimateItem.item_taxes || []).map((tax) => ({
            value: tax.taxrate,
            label: tax.taxname,
            taxrate: Number(tax.taxrate || 0),
            taxname: tax.taxname || "",
          }))
      );
  
      return {
        id: item.id || `edit-${index}`,
  
        item: item.description || "",
  
        description: item.long_description || "",
  
        long_description: item.long_description || "",
  
        productId: item.item_id || null,
  
        hsn: item.hsn || "",
  
        qty,
  
        hours: 0,
  
        rate,
  
        amount: qty * rate,
  
        unit: item.unit || "",
  
        // BOTH CGST AND SGST
        taxes: itemTaxes,
  
        selectedTaxes: itemTaxes,
  
        isSaved: true,
      };
    });
  
    console.log(
      "EDIT FORMATTED ITEMS:",
      formattedItems
    );
  
    setProductData((prev) => ({
      ...prev,
      items: formattedItems,
    }));
  }, [estimateDetails]);

  useEffect(() => {
    const estimate = estimateDetails?.Estimate;
  
    if (!estimate) return;
  
    const customer = customerOptions.find(
      (item) =>
        Number(item.value) ===
        Number(estimate.clientid)
    );
  
    if (customer) {
      setSelectedCustomer(customer);
    }
  
    const country = countries.find(
      (item) =>
        Number(item.value) ===
        Number(estimate.billing_country)
    );
  
    if (country) {
      setSelectedCountry(country);
    }
  }, [
    estimateDetails,
    customerOptions,
    countries,
  ]);

  //update estimate api

  const updateEstimate = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        id: Number(id),
      
        clientid: selectedCustomer?.value,
      
        project_id: Number(formData.project_id || 0),
      
        number: Number(
          estimateDetails?.Estimate?.number || 0
        ),
      
        prefix:
          estimateDetails?.Estimate?.prefix || "EST",
      
        date: startDate
          ? dayjs(startDate).format("YYYY-MM-DD")
          : null,
      
        expirydate: endDate
          ? dayjs(endDate).format("YYYY-MM-DD")
          : null,
      
        currency: Number(
          productData.currencyId || 5
        ),
      
        subtotal: Number(
          productData.subtotal || 0
        ),
      
        total_tax: Number(
          productData.totalTax || 0
        ),
      
        total: Number(
          productData.total || 0
        ),
      
        adjustment: Number(
          formData.adjustment || 0
        ),
      
        addedfrom: Number(
          estimateDetails?.Estimate?.addedfrom ||
          userId
        ),
      
        status: Number(
          estimateDetails?.Estimate?.status || 1
        ),
      
        clientnote:
          formData.clientnote || "",
      
        adminnote:
          formData.adminnote || "",
      
        discount_percent: Number(
          productData.discount || 0
        ),
      
        discount_total: Number(
          productData.discountAmount || 0
        ),
      
        discount_type:
          productData.discountType || "after",
      
        terms:
          formData.terms || "",
      
        reference_no:
          formData.reference_no || "",
      
        sale_agent: Number(
          estimateDetails?.Estimate?.sale_agent ||
          userId
        ),
      
        billing_street:
          formData.street || "",
      
        billing_city:
          formData.city || "",
      
        billing_state:
          formData.state || "",
      
        billing_zip:
          formData.zip || "",
      
        billing_country:
          Number(selectedCountry?.value || 0),
      
        shipping_street:
          formData.shipping_street || "",
      
        shipping_city:
          formData.shipping_city || "",
      
        shipping_state:
          formData.shipping_state || "",
      
        shipping_zip:
          formData.shipping_zip || "",
      
        shipping_country:
          Number(
            formData.shipping_country ||
            selectedCountry?.value ||
            0
          ),
      
        items: (productData.items || []).map((item) => ({
          item_id: Number(
            item.productId ||
            item.item_id ||
            0
          ),
      
          description:
            item.item ||
            item.description ||
            "",
      
          long_description:
            item.long_description ||
            item.description ||
            "",
      
          qty: Number(
            item.qty || 0
          ),
      
          rate: Number(
            item.rate || 0
          ),
      
          unit:
            item.unit || "",
      
          item_taxes: (
            item.selectedTaxes ||
            item.taxes ||
            []
          ).map((tax) => ({
            taxname:
              tax.taxname ||
              tax.label ||
              "",
      
            taxrate:
              Number(tax.taxrate || 0),
          })),
        })),
      };
      
      console.log(
        "UPDATE ESTIMATE PAYLOAD:",
        payload
      );

      console.log("UPDATE ESTIMATE PAYLOAD:", payload);

      // const response = await axios.post(
      //   `${BASE_CRM_URL}estimates/UpdateEstimate`,
      //   payload,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      const response = await fetch(`${BASE_CRM_URL}estimates/UpdateEstimate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Updated",
          text: data.Message || "Estimate updated successfully",
        });

        navigate("/crm/estimates");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message || "Failed to update estimate",
        });
      }
    } catch (error) {
      console.error("Update Estimate Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.Message || "Failed to update estimate",
      });
    } finally {
      setSaving(false);
    }
  };

  //ui tabs content

  const tabItems = [
    {
      key: "1",
      label: (
        <>
          <i className="bi bi-person-lines-fill me-2"></i>
          Customer
        </>
      ),
      children: (
        <>
          <div className="row">
            <div className="mb-2 col-3">
              <label>Customer</label>
              <Select
                showSearch
                placeholder="Select Customer"
                optionFilterProp="label"
                className={`w-100 ${
                  isCustomerPrefilled ? "prefilled-select" : ""
                }`}
                style={{ height: 38 }}
                options={customerOptions}
                value={selectedCustomer}
                onChange={(value) => {
                  setSelectedCustomer(value);
                  // getCustomerDetails(value);
                }}
              />
            </div>
            <div className="mb-3 col-3">
              <label>Estimated Date</label>
              <DatePicker
                value={startDate}
                format="DD-MM-YYYY"
                className="w-100"
                onChange={(date) => {
                  setStartDate(date);

                  if (date) {
                    setEndDate(date.add(15, "day"));
                  } else {
                    setEndDate(null);
                  }
                }}
              />
            </div>

            <div className="mb-3 col-3">
              <label>Expiry Date</label>

              <DatePicker
                value={endDate}
                format="DD-MM-YYYY"
                className="w-100"
                onChange={(date) => setEndDate(date)}
              />
            </div>
            <div className="mb-2 col-3">
              <label> (Bill To) Street</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Street"
                value={formData.street}
                onChange={(e) =>
                  setFormData({ ...formData, street: e.target.value })
                }
              />
            </div>

            <div className="mb-2 col-3">
              <label>City</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter City"
                value={formData.city}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
              />
            </div>

            <div className="mb-2 col-3">
              <label>State</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter State"
                value={formData.state}
                onChange={(e) =>
                  setFormData({ ...formData, state: e.target.value })
                }
              />
            </div>

            <div className="mb-2 col-3">
              <label>Zip Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Zip Code"
                value={formData.zip}
                onChange={(e) =>
                  setFormData({ ...formData, zip: e.target.value })
                }
              />
            </div>

            <div className="mb-2 col-3">
              <label>Country</label>
              <Select
                style={{ height: 38 }}
                className={`w-100 ${
                  isCustomerPrefilled ? "prefilled-select" : ""
                }`}
                placeholder="Select Country"
                options={countries}
                value={selectedCountry}
                loading={countryLoading}
                onChange={(value) => {
                  setSelectedCountry(value);
                  setIsCustomerPrefilled(false);
                }}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </div>

            <div className="mb-2 col-3">
              <label>Reference #</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Reference #"
                value={formData.reference_no || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    reference_no: e.target.value,
                  }))
                }
                required
              />
            </div>

            <div className="mb-2 col-9">
              <label>Admin Note</label>
              <textarea
                className="form-control"
                placeholder="Enter text here"
                rows="1"
                value={formData.adminnote}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    adminnote: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <i className="bi bi-cart3 me-2"></i>
          Items & Totals
        </>
      ),
      children: (
        <>
          <EditProducttable
            currencyId={productData.currencyId}
            discount_type={productData.discountType}
            initialDiscount={productData.discount}
           
            initialItems={productData.items}
            onProductDataChange={setProductData}
          />
        </>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item">
            <div className="d-flex flex-column">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Edit Estimate
                  </h4>
                </ol>
              </nav>
              <p className="text-muted">Edit a New Estimate here</p>
            </div>
          </div>
          <div className="page-btn d-flex jusitfy-content-between">
            <Link
              to="/crm/estimates"
              className="btn btn-secondary btn-sm d-flex align-items-center"
            >
              <i className="ti ti-arrow-left fs-4 "> </i>
            </Link>
          </div>
        </div>

        <div className="card">
          <div className="card-header ">
            <h4 className="text-primary">{formData.estimate_to || "-"}</h4>
          </div>
          <div className="card-body ">
            <form onSubmit={updateEstimate}>
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                size="large"
                tabBarGutter={30}
                animated
              />

              <div className="d-flex justify-content-end mt-2">
                <button type="submit" className="btn btn-info me-2">
                  Save & Send
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <CommonFooter />
      </div>
      <>
        <BillTo />
      </>
    </div>
  );
};

export default EditEstimate;
